import { types as jobTypes } from '@saucelabs/sl-module-jobs';

import * as types from './types';

const initialState = {};

const fileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobTypes.RAW_JOB_GET.SUCCESS:
      return payload;
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default fileReducer;
